import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import { withRouterJim } from "router/withRouterJim";

import NuLoading from 'components/nubox/NuLoading'; 

import pdficon from 'assets/img/pdficon.png';


//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class ResetPassEst extends React.Component {
  state = {

    isLoading:false,
    
    //id_prod, nombre_p, descrip, preciov1, color
    form: {
      idd:0,
      ope:'n',  
      clave: '',
      
    },
    resultado:'',
    
  };
  

  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){
      //console.log("cheched:"+ e.target.checked);
      let res = e.target.checked? 1:0;
      //console.log("value:"+ res);
      
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //------------------
  btn_click=(e)=>{
    e.preventDefault();
    //href="ttp://localhost:8080/educo/public/api/debug_compare_db_get_db"

    let fileURL = process.env.REACT_APP_API_URL + "debug_compare_db_get_db";
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  //-------------------------------------
  save =(e) =>{
    console.log("save")
    e.preventDefault()

      let param = {clave : this.state.form.clave}
      console.log(param);

      this.setState({ isLoading: true })
      axios2.post( "reset_pass_est_store", param)
      .then(res => {
          console.log("res.data")
          console.log(res.data)
          this.setState({ isLoading: false }) 

          if(res.data.exito === 1){ 
              toast.success(res.data.men);
              this.setState({ resultado: res.data.cad  });
              
          }else{
              toast.error(res.data.men);
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);  
      });
    
  }
  //-------------------------------------
  render() {

    return (
      <div className="content">
        <ToastContainer />
        <div className="row justify-content-center">

          <div className="col-md-7">

            {
              //JSON.stringify(this.state)
            }

            {/*<!-- /.card -->*/}
            <form id="form01" name="form01" method="post">
              
                <div className="card card-primary">
                  <div className="card-header" 
                      style={{ backgroundColor: '#007bff', color: 'white'}}>
                    <h4 className="card-title m-0">Reset pass estudiantes</h4>
                  </div>
                  {/*<!-- /.card-header -->*/}

                  <div className="card-body bg-grey">
                    <div className="">

                      <table className="tabla04" width="100%">
                        <tbody>
                          <tr>
                            <td className="celda-blue" colspan="2">Autorización</td>
                          </tr>

                          <tr>
                            <td><span className="data_error">*</span> Clave:</td>
                            <td>
                              <input type="password" 
                                     name="clave"
                                     className="form-control input-sm" 
                                     style={{width: '150px' }} 
                                     value={this.state.form.clave}
                                     onChange={this.handleChangeForm}
                                     />
                            </td>
                          </tr>

                          {/*<!---------------------------------------------->*/}

                          <tr>
                            <td className="celda-blue" colspan="2">Consola de salida</td>
                          </tr>
                          <tr>
                            <td>

                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                    
                  </div>
                  {/*<!-- /.card-body -->*/}

                  <div className="card-footer text-center">
                    <button className="btn btn-primary" onClick={(e)=> this.save(e) } >Guardar</button>
                  </div>

                  {/*<!-- resultado jquery-->*/}
                  <NuLoading text="Cargando...." show= { this.state.isLoading }/>
                  <div dangerouslySetInnerHTML={{__html: this.state.resultado }}></div>

                </div>

            </form>
          </div>


        </div>

      </div>
    );
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(ResetPassEst);